<template>
  <div>
    <homeNav @switchTab="switchTab" />
    <div>
      <img :src="baseOSSUrl + '/banner1.png'" class="w-full bgImg" alt="">
    </div>
    <clinicalTabs ref="child" />
    <backtop />
    <homeFooter />
  </div>
</template>

<script>
  import backtop from "@/components/backtop";
  import homeFooter from "@/components/homeFooter";
  import homeNav from "@/components/homeNav";
  import {
    baseOSSUrl
  } from '@/utils/oss';
  import clinicalTabs from "@/views/clinical/components/clinicalTabs";
  export default {
    name: "clinicalService",
    data() {
      return {
        tabIndex: 0, //默认tabs
        baseOSSUrl
      }
    },
    components: {
      homeNav,
      clinicalTabs,
      backtop,
      homeFooter
    },
    created() {
      this.tabIndex = this.$route.query.tabIndex;
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.child.switchTab(this.tabIndex);
      })
    },
    watch: {
      $route(to, from) {
        //首页传入的tabIndex 和所在页面tabIndex不相等就切换tab
        if (this.tabIndex != this.$route.query.tabIndex) {
          this.tabIndex = this.$route.query.tabIndex;
          this.$refs.child.switchTab(this.tabIndex);
        }
      }
    },
    methods: {
      switchTab(index) {
        this.$nextTick(() => {
          this.$refs.child.switchTab(index);
        })
      }
    },
  }
</script>

<style scoped>
  .bgImg {
    height: 16.25rem;
  }
</style>